import api from '../apis/ufrnApi'

const libraryService = () => {
    let url = '/bibliotecas/?limit=100&offset=0'
    return api.get(url)
}

export const libraryGeneralService = () => {
    let url = '/bibliotecas-geral/'
    return api.get(url)
}

export default libraryService